import React from 'react';

const Vdo = () => (
    <div class="embed-responsive embed-responsive-21by9">
  <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/cC_SXmfxtDw"></iframe>
</div>
)

export default Vdo;


